export const firstYearTracked = 2017;